module.exports = __webpack_public_path__ + "img/vk_icon.f68fd7d6.svg";